import { atom, useRecoilValue } from 'recoil'
export type SnackbarStoreType = {
    isOpen: boolean
    type: 'success' | 'info' | 'warning' | 'error'
    message: string
}
export const snackbarStore = atom<SnackbarStoreType>({
    key: 'snackbarStore',
    default: {
        isOpen: false,
        type: 'success',
        message: '',
    },
})

const useSnackbarStore = () => {
    const snackbarState = useRecoilValue(snackbarStore)
    return {
        ...snackbarState,
    }
}

export default useSnackbarStore
